import { useQuery } from "@apollo/client";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, CircularProgress, Link, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink, useParams } from "react-router-dom";
import CoverEditFormCont from "../containers/CoverEditFormCont";
import { QUERY_COVER } from "../gql/queries/cover";
import { truncateWithEllipses } from "../helpers/utils";
import { Spacing } from "../types/enum";

const CoversEditPage: React.FC = () => {
  const params = useParams<Record<string, string>>();

  const { data, loading } = useQuery(QUERY_COVER, {
    fetchPolicy: "network-only",
    variables: {
      id: params?.coverId,
    },
  });

  if (loading) {
    return <CircularProgress />;
  }

  const cover = data?.adminGetCover;

  return (
    <>
      <Box display="flex" alignItems="center" mb={Spacing.m}>
        <Link color="inherit" component={RouterLink} to="/covers">
          <Box mr={Spacing.sm}>
            <ArrowBackIcon />
          </Box>
        </Link>

        <Typography variant="h3" color="textPrimary">
          {truncateWithEllipses(cover?.title)}
        </Typography>
      </Box>

      <CoverEditFormCont cover={cover} />
    </>
  );
};

export default CoversEditPage;
